import * as constants from './Setting.constants';
import * as services from './Setting.service';

import { DEFAULT_DATA_URL_DATA, DEFAULT_DATA_URL } from '@/constants/index';

const genDefaultDataWechatQrcodeInfo = () => ({
  qrcode: DEFAULT_DATA_URL_DATA,
  wechatCode: '',
});

const genDefaultUrlWechatQrcodeInfo = () => ({
  qrcode: DEFAULT_DATA_URL,
  wechatCode: '',
});

const state = {
  isRequest: false,
  isNicknameCheckExistRequest: false,
  isNicknameIsUnique: true,
  isNicknameMatchFormat: true,
  countries: [],
  //
  wechatQrcodeInfo: genDefaultUrlWechatQrcodeInfo(),
};

const mutations = {
  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.SET_IS_NICKNAME_CHECK_EXIST_REQUEST_STATUS](state, status) {
    state.isNicknameCheckExistRequest = status;
  },

  [constants.POST_CHECK_NICKNAME_SUCCESS](state, data) {
    state.isNicknameIsUnique = data.isUnique;
    state.isNicknameMatchFormat = data.matchFormat;
  },

  [constants.GET_MALL_COUNTRIES_SUCCESS](state, countries) {
    if (undefined !== countries && null !== countries) {
      state.countries = countries;
    }
  },

  //
  [constants.GET_WECHAT_QRCODE_SUCCESS](state, data) {
    if (data.data.qrcode) {
      state.wechatQrcodeInfo = {
        qrcode: 'data:image/gif;base64,' + data.data.qrcode,
        wechatCode: data.data.wechatCode,
      };
    }
  },

  //
  [constants.DUMMY_MUTATION]() {
    //
  },
};

const actions = {
  async checkExistNickname({ commit }, payload) {
    commit(constants.SET_IS_NICKNAME_CHECK_EXIST_REQUEST_STATUS, true);
    const res = await services.checkExistNickname(payload);
    commit(constants.POST_CHECK_NICKNAME_SUCCESS, res.data.data);
    commit(constants.SET_IS_NICKNAME_CHECK_EXIST_REQUEST_STATUS, false);
    return res;
  },

  async getMallCountries({ commit }, payload) {
    const res = await services.getMallCountries(payload);
    commit(constants.GET_MALL_COUNTRIES_SUCCESS, res.data.data);
  },

  async validateEmail({ commit }, payload) {
    const pms = services.validateEmail(payload);
    const res = await pms;
    commit(constants.DUMMY_MUTATION, res.data.data);
    return pms;
  },

  async _prepurchase({ dispatch, commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const pms = payload.prepurchase(payload.payload);
    const res = await pms;
    if (res.data.status === 200) {
      dispatch('getUserInfo', null, { root: true });
    }
    commit(constants.DUMMY_MUTATION);
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return pms;
  },

  prepurchaseFromWechat({ dispatch }, payload) {
    return dispatch('_prepurchase', {
      payload,
      prepurchase: services.prepurchaseFromWechat,
    });
  },

  prepurchaseFromEmail({ dispatch }, payload) {
    return dispatch('_prepurchase', {
      payload,
      prepurchase: services.prepurchaseFromEmail,
    });
  },

  //
  async getWechatQrcode({ commit }, payload) {
    commit(constants.GET_WECHAT_QRCODE_SUCCESS, {
      data: genDefaultDataWechatQrcodeInfo(),
    });
    const res = await services.getWechatQrcode(payload);
    commit(constants.GET_WECHAT_QRCODE_SUCCESS, res.data);
    return res;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
